module.exports = __webpack_public_path__ + "static/media/nps_down.4d4eb320.svg";